import { DefaultState, INotificationState } from "./state";
import { Keys, Types } from "./actions/types";
import { Keys as KeysInfos, Types as TypesInfos } from "../infos/actions/types";
import { KeysPost, TypesPost } from "../posts/actions/types";
import { Keys as KeysContacts, Types as TypesContacts } from "../contacts/actions/types";
import { Keys as KeysSubscription, Types as TypesSubscription } from "../../../common/store/subscriptions/actions/types";

export const reducer = (state: INotificationState = DefaultState(), action: Types | TypesPost | TypesInfos | TypesContacts | TypesSubscription): INotificationState => {
    // console.log("ACTION TYPE:", action.type);
    // console.log("ACTION PAYLOAD:", action.payload);
    switch (action.type) {
        case KeysContacts.SAVECARDNUMBER:
        case KeysContacts.SAVEBLOCKACCESSDATE:
        case KeysContacts.SAVEGREENPASS:
        case KeysContacts.ADDROOM_FULFILLED:
        case KeysContacts.UPDATEROOM_FULFILLED:
        case KeysSubscription.ADDCONTACTSUBSCRIPTION_FULFILLED:
        case KeysSubscription.SAVECONTACTSUBSCRIPTION_FULFILLED:
        case KeysSubscription.REMOVEACCESSCONTACTSUBSCRIPTION_FULFILLED:
        case KeysSubscription.ADDCONTACTMEDICAL_FULFILLED:
        case KeysSubscription.SAVECONTACTMEDICAL_FULFILLED:
        case KeysSubscription.SAVECONTACTINSURANCE_FULFILLED:
        case KeysSubscription.ADDCONTACTINSURANCE_FULFILLED:
        case KeysPost.ADDPOST_FULFILLED:
        case KeysInfos.SAVEINFOS_FULFILLED: {
            let p: customNotification = { result: true, message: 'Dati salvati!' };
            return {
                ...state,
                saveNotification: p // .saveNotificationValue
            }
        }
        case Keys.SHOWNOTIFICATION: {
            // console.log("ACTION PAYLOAD TYPE:", typeof (action.payload), ("saveNotificationValue" in action.payload ? true : false));
            // let p: customNotification = { result: true, message: 'Dati salvati!' };
            // if (("saveNotificationValue" in action.payload === true)) {
            //     p = action.payload;
            // }
            // else {
            //     p = { saveNotificationValue: true };
            // }
            return {
                ...state,
                saveNotification: action.payload // .saveNotificationValue
            }
        }
        default:
            return state;
    }
}